<script setup>
  defineProps({
    breadcrumbs: Array,
    sections: Array,
    module: Object,
  });
</script>
<template>
  <main class="container">
    <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
    <h1 class="privacy-policy-heading">{{ module.title }}</h1>
    <p class="privacy-policy-description">
      {{ module.description_short }}
    </p>
    <SectionRenderer :sections="sections" />
  </main>
</template>
<style scoped lang="scss">
  .privacy-policy-description {
    margin: 1rem 0 2rem;
  }

  @media(max-width: 992px) {
    .privacy-policy-heading,
    .privacy-policy-description {
      padding: 0 0.625rem;
    }
  }
</style>